module.exports = __webpack_public_path__ + "img/aimPoint7.229bc727.png";